module.exports = __webpack_public_path__ + "static/media/information.07cdea2c.svg";